import { gql, useLazyQuery } from "@apollo/client";
import { useAuth } from "@src/common/hooks/useAuth";
import { useEffect } from "react";
import { OrderInvoiceStatusResult } from "../types/OrderInvoiceStatusResult";

const INVOICE_BY_ORDER_ID_QUERY = gql`
  query GetInvoiceByOrderId($courierId: ID!, $orderId: ID!) {
    invoiceByOrderId(courierId: $courierId, orderId: $orderId) {
      invoiceNumber
      status
      invoicePaymentStatus
    }
  }
`;

export function useOrderInvoiceStatus(orderId: string) {
  const { courierId } = useAuth();
  const [fetch, { data, loading, called }] = useLazyQuery<OrderInvoiceStatusResult>(
    INVOICE_BY_ORDER_ID_QUERY,
    { fetchPolicy: "cache-and-network" }
  );

  useEffect(() => {
    if (!courierId) return;
    fetch({ variables: { courierId, orderId } });
  }, [courierId, orderId]);

  return {
    invoiceNumber: data?.invoiceByOrderId?.invoiceNumber ?? null,
    invoiceStatus: data?.invoiceByOrderId?.status ?? null,
    invoicePaymentStatus: data?.invoiceByOrderId?.invoicePaymentStatus ?? null,
    loading,
    called,
  };
}
